<template>
  <div 
    :class="{'colorized': isColorized, 'has-image': hasImage, 'input-in-flow': answer.input_in_flow, 'has-error': !isValid, 'has-override-by-contact': overrideByContactForm, 'no-head-space': answer.no_space }"
    class="ec-answer ec-number"
    @click="selectAnswer($event, answer.id)">
    <span 
      v-show="effectedWarningEnabled" 
      :aria-label="this.$t('answers.change_warning_msg')"
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true"/>
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
      <div 
        :class="{'invalid-answer-input':!isValid && value !== ''}"
        class="ec-answer-input">
        <div class="ec-answer-input-number">
            <template v-if="!overrideByContactForm">
          <div class="ec-answer-input-form">
            <div 
              v-show="!isValid && value !== ''"
              class="ec-answer-input-error-marker hint--bottom hint--small hint--error" 
              aria-label="ungültig">
              <i class="fa fa-exclamation" />
            </div>
            <input 
              :disabled="isFormDisabled"
              type="text"
              class="number-input"
              v-on:input="changed"
              @focus="gotFocus">
          </div>
          <div
            v-show="unitType"
            class="ec-answer-input-unit">{{ unitType }}</div>
             </template>
              <div class="ec-answer-input-overlay" v-if="overrideByContactForm">
                <a href="#" @click.stop="callContactModal" class="btn is-blue" style="min-width:150px" v-text="$t('general.contact_btn')" />
              </div>
        </div>
      </div>
      <div 
        v-if="answer.text_behind" 
        class="ec-answer-text-behind" 
        v-html="answer.text_behind"/>
    </div>
    <div 
      v-if="hasImage" 
      class="ec-answer-image" 
      @click="showImage">
      <div class="ec-answer-img-wrapper">
        <div class="ec-answer-img-overlay">
          <div class="ec-img-overlay-icon"><i 
            aria-hidden="true" 
            class="fa fa-search"/></div>
        </div>
        <img :src="imageSrc">
      </div>
    </div>
    <AnswerDebug 
      v-if="answer.additional_informations" 
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<style>

</style>
<script>
    import IMask from 'imask'
    import {toNumber, round} from 'lodash'
    import Answer from './Answer.vue'
    
    export default {
        name: "NumberAnswer",
        extends: Answer,
        data: function () {
            return {
                value: this.initValue === '' ? '' : round(this.initValue),
                disabled: false,
                liveFormula: null,
                changedByUser: false,
                inputMask: null
            }
        },
        computed: {
            isValid: function () {
                if (!this.isMinValueValid) {
                    return false
                }

                if (!this.isMaxValueValid) {
                    return false
                }

                return !this.required || (this.value && this.value.toString().trim().length > 0)
            },
            isMinValueValid: function() {
                if(this.value === '') {
                    return true
                }

                let value = toNumber(this.value)

                if (this.answer.input_number_min_value && value < toNumber(this.answer.input_number_min_value)) {
                    return false
                }

                return true
            },
            isMaxValueValid: function() {
                let value = toNumber(this.value)

                if (this.answer.input_number_max_value && value > toNumber(this.answer.input_number_max_value)) {
                    return false
                }

                return true
            },
            unitType: function () {
                switch (this.answer.unit_type) {
                    case 'currency':
                        return "EUR"
                    case 'pot-mins':
                        return "Min."
                    case 'pot-days':
                        return "Tage"
                    case 'pot-weeks':
                        return "Wochen"
                    case 'length-m':
                        return "m"
                    case 'length-km':
                        return "km"
                    case 'area-sm':
                        return "qm"
                    case 'amount':
                        return "Stück"
                    case 'persons':
                        return "Personen"
                    default:
                        return null
                }
            }, 
            isFormDisabled() {
                return this.$store.readOnly || this.disabled
            }
        },
        watch: {
            value: {
                handler: function (value) {
                    return round(value)
                },
                immediate: true
            }
        },
        created() {
            if(this.answer.input_formula_bind) {
                this.$store.liveFormulas.push([this.answer.input_formula_bind, {formatte: false}])

                this.$event.$on('start-recalculation', () => {
                    if(!this.changedByUser) {
                        this.disabled = true
                    }
                })

                this.$event.$on('new-data', (data) => {
                    if(this.changedByUser) {
                        this.changedByUser = false
                    } else {
                        let newValue = round(data.formulas[this.answer.input_formula_bind])
                        this.value = newValue
                        this.inputMask.typedValue = newValue
                        this.disabled = false
                    }
                }) 
            }
        },
        mounted() {
            const inputEl = this.$el.querySelector('.number-input')
            
            if(inputEl) {
                this.inputMask = new IMask(inputEl, {
                    mask: Number,  // enable number mask
                    signed: true,  // disallow negative
                    thousandsSeparator: '.',  // any single char
                })

                this.inputMask.typedValue = this.value

                this.inputMask.on("accept", () => {
                    this.value = this.inputMask.unmaskedValue
                })
            }            
        },
        methods: {
            gotFocus() {
                this.changedByUser = true
            },
            changed(event) {
                this.selectAnswer(event, this.answer.id)
            }
        }
    }
</script>